module.exports = __webpack_public_path__ + "img/rendlej.45c78424.jpg";